const steps = document.querySelectorAll('.stepsblock');

for( i=0; i< steps.length; i++ ) {
  
    steps[i].classList.add('stepsblock-swiper-container-' + i);

    var slider = new Swiper('.stepsblock-swiper-container-' + i +' .steps-col' , {
 
        freeMode: true,
        watchOverflow: true,
        preventClicks: true,
        preventClicksPropagation: true,
        navigation: {
            nextEl: '.stepsblock.stepsblock-swiper-container-' + i + ' .swiper-button-next',
            prevEl: '.stepsblock.stepsblock-swiper-container-' + i + ' .swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1000,
                spaceBetween: 16
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 16
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 16
            }
        }
    });

}